import createRequestActions, {
  createRequestActionNames,
} from './createRequestActions';
import { requestResetPasswordEmail, requestResetPassword } from '../lib/api';

const initialState = {
  forgotPassword: null,
  resetPassword: null,
};

export const [
  FORGOT_PASSWORD_REQUEST,
  FORGOT_PASSWORD_SUCCESS,
] = createRequestActionNames('[FORGOT] forgotPassword');

export const [
  RESET_PASSWORD_REQUEST,
  RESET_PASSWORD_SUCCESS,
] = createRequestActionNames('[FORGOT] resetPassword');

const _forgotPassword = createRequestActions('[FORGOT] forgotPassword');
const _resetPassword = createRequestActions('[FORGOT] resetPassword');

export const forgotPassword = email => dispatch => {
  dispatch(_forgotPassword.request(email));

  requestResetPasswordEmail(email)
    .then(response => dispatch(_forgotPassword.success(response)))
    .catch(error => dispatch(_forgotPassword.error(error)));
};

export const resetPassword = (token, password) => dispatch => {
  dispatch(_resetPassword.request(token, password));

  requestResetPassword(token, password)
    .then(response => dispatch(_resetPassword.success(response)))
    .catch(error => dispatch(_resetPassword.error(error)));
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;

  switch (type) {
    case FORGOT_PASSWORD_SUCCESS:
      return { ...state, forgotPassword: payload.forgotPassword };
    case RESET_PASSWORD_SUCCESS:
      return { ...state, forgotPassword: payload.resetPassword };
    default:
      return state;
  }
}
